<template>
    <div class=" my">
        <img src="../../assets/logotable.png" style="position:fixed;top:0.8rem;z-index:9;height:1.5rem;right:50vw;">
        <nav-bar title="活动统计"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft"
                 class="my-nav">
        </nav-bar>
        <div style="margin-top: 2.9rem"></div>

        <!-- 上滑进入 -->
        <cell-group title="活动列表">
            <collapse v-model="activeNames">
                <div v-for="(v,i) in list" :key="i">
                    <collapse-item :title="v.activityName" :name="i">
                        <ant-row>
                            <ant-col span="6">
                                <div>人数上限:</div>
                                <div>预算金额:</div>
                                <div>报名截止:</div>
                                <div>开始时间:</div>
                                <div>结束时间:</div>
                                <div>活动状态:</div>
                                <div>报销状态:</div>
                            </ant-col>
                            <ant-col span="18">
                                <div>{{v.numberPeople}}</div>
                                <div>{{v.budget}}</div>
                                <div>{{v.activityFinishTime | ptime}}</div>
                                <div>{{v.activityStartTime | ptime}}</div>
                                <div>{{v.activityEndTime | ptime}}</div>
                                <div>{{v.approveStatus | pstatus}}</div>
                                <div>{{v.budgetResult | pbstatus}}</div>
                            </ant-col>
                        </ant-row>
                        <div v-if="v.appUser">

                            活动发起人
                            <divider dashed />
                            <ant-row style="margin-top: 10px">
                                <ant-col :span="6">
                                    <ant-image  round width="3rem" height="3rem" :src="v.appUser.headimgurl"/>
                                </ant-col>
                                <ant-col :span="16">
                                    <div>{{v.appUser.phone}}</div>
                                    <div>{{v.appUser.userName}}</div>
                                    <div>{{v.appUser.sex==1?'男':'女'}}</div>
                                </ant-col>
                                <ant-col :span="2">
                                    <a :href="'tel:'+v.appUser.phone">
                                        <icon name="phone-circle" size="35px" color="dodgerblue"/>
                                    </a>
                                </ant-col>
                                <ant-row>
                                    <ant-col :span="6">
                                        <div>公司</div>
                                    </ant-col>
                                    <ant-col :span="16">
                                        {{v.appUser.deptName}}
                                    </ant-col>
                                </ant-row>
                            </ant-row>
                        </div>

                        活动内容
                        <divider dashed />
                        <ant-row style="margin-top: 10px">
                            <div class="grey-box" style="min-height: auto">
                                <div class="ql-container ql-snow" style="border:none">
                                    <div class="ql-editor" data-gramm="false" contenteditable="false"
                                         v-html="v.activityContent">
                                    </div>
                                </div>
                            </div>
                        </ant-row>
                        <ant-row style="text-align:center ">
                            <ant-button @click="updateImg(v)" size="small"
                                        class="btn" type="info">
                                活动图片
                            </ant-button>
                            <ant-button @click="applicants(v)" size="small"
                                        class="btn" plain type="primary">
                                报名人员
                            </ant-button>
                        </ant-row>
                    </collapse-item>
                </div>
            </collapse>
            <!-- 分页-->
            <pagination v-model="page" :total-items="total" mode="simple" @change="init()" v-if="list.length"/>
            <empty v-else description="暂无数据"/>
        </cell-group>

    </div>
</template>

<script>
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row, Pagination, Dialog, Icon, SwipeCell, Empty, Image
    } from 'vant'
    import service from "../../api/service";
    import {quillEditor} from "vue-quill-editor";
    import moment from "moment";
    // 总揽
    export default {
        name: "activityOverview",
        components: {
            Cell,
            CellGroup,
            NavBar,
            Divider,
            AntButton: Button,
            AntForm: Form,
            AntField:
            Field,
            DatetimePicker,
            Popup,
            Collapse,
            CollapseItem,
            AntCol: Col,
            AntRow: Row,
            Pagination,
            Dialog,
            quillEditor,
            Icon, SwipeCell, Empty, AntImage: Image
        },
        data() {
            return {
                list: [],
                total: 0,
                page: 1,
                activeNames: [],
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity-overview', {
                    page: this.page,
                    deptId: sessionStorage.getItem("deptId")
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                        this.total = res.total
                    }
                })
            },
            //跳转
            updateImg(v) {
                this.$router.push({path: '/activityImg', query: {id: v.id,url:'/activityOverview'}})
            },
            //活动报名人员
            applicants(v) {
                this.$router.push({path: '/applicants', query: {id: v.id,url:'/activityOverview'}})
            },
            //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
        },
        filters: {
            ptime(v) {
                return v ? moment(v).format("YYYY-MM-DD HH:mm:ss") : '-';
            },
            pstatus(v) {
                switch (v) {

                    case '0':
                        return '未提交';
                    case '1':
                        return '审批中';
                    case '2':
                        return "通过";
                    case '3':
                        return '未通过'

                }
            },
            pbstatus(v) {
                switch (v) {
                    case '0':
                        return '未提交';
                    case '1':
                        return '审批中';
                    case '2':
                        return '通过';
                    case '3':
                        return '未通过'
                }
            },
        }
    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }

    .btn {
        margin: 1rem 0.5rem;
    }
</style>